// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/user-plus.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/user-plus'

import { Icon, type IconComponentProps } from '../icon'

export const UserPlusIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
